window.localeDateFormat = {
  regex: /(19|20)\d\d[- \/.](0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])/,
  placeholder: '년/월/일',
  dateFormat: 'yy/mm/dd'
};
